import { TaskOperatorComponent } from './task-operator/task-operator.component';
import { IdentificationDataOperatorComponent } from './identification-data/identification-data-operator.component';
import { NotificationsOperatorComponent } from './notifications-operator/notifications-operator.component';
import { PlacesOperatorComponent } from './places-operator/places-operator.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OperatorRoutingModule } from './operator-routing.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {Ng2SmartTableModule} from 'ng2-smart-table';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CKEditorModule} from 'ngx-ckeditor';
import { ElectricityOperatorComponent } from './electricity-operator/electricity-operator.component';
import { GasOperatorComponent } from './gas-operator/gas-operator.component';
import { NetworkContractTaskComponent } from './task-operator/details/network-contract-task/network-contract-task.component';
import {SignaturePadModule} from 'angular2-signaturepad';
import {PublicModule} from '../../public/public.module';
import {ElectricityConsumptionPlaceComponent} from "./electricity-operator/consumption-place/electricity-consumption-place.component";
import {GasConsumptionPlaceComponent} from "./gas-operator/consumption-place/gas-consumption-place.component";
import { ImpossibilitySupplyComponent } from './impossibility-supply/impossibility-supply.component';
import {SharedModule} from '../../shared/shared.module';
import { OperatorInvitationsComponent } from './identification-data/details/operator-invitations.component';
import {NetworkContractElectricityComponent} from "./electricity-operator/network-contract/network-contract-electricity.component";
import {NetworkContractGasComponent} from "./gas-operator/network-contract/network-contract-gas.component";

@NgModule({
  declarations: [
    TaskOperatorComponent,
    IdentificationDataOperatorComponent,
    NotificationsOperatorComponent,
    PlacesOperatorComponent,
    ElectricityOperatorComponent,
    GasOperatorComponent,
    NetworkContractTaskComponent,
    ElectricityConsumptionPlaceComponent,
    ImpossibilitySupplyComponent,
    GasConsumptionPlaceComponent,
    OperatorInvitationsComponent,
    NetworkContractElectricityComponent,
    NetworkContractGasComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    Ng2SmartTableModule,
    ReactiveFormsModule,
    CKEditorModule,
    FormsModule,
    OperatorRoutingModule,
    SignaturePadModule,
    PublicModule,
    SharedModule
  ]
})
export class OperatorModule { }
